import { endpoints } from '../Constants';
import { authHeader, toQueryStringURL } from '../Helpers';
import handleResponse from './helpers';

const variantBatchSizeServices = {
	getBatchSizeList,
	createBatchSizeMapping,
};

/**
 * Get batch size mapping for a store
 * @param {Object} req - Request object with params containing storeId
 * @returns {Promise} - API response
 */
function getBatchSizeList(req = {}) {
	const params = {
		...req.params,
	};

	const url = toQueryStringURL(endpoints.VARIANT_BATCH_SIZE_LIST, params);

	const requestOptions = {
		method: 'GET',
		headers: {
			'Content-Type': 'application/json',
			...authHeader(),
		},
	};

	return fetch(url, requestOptions).then(handleResponse);
}

/**
 * Create or update batch size mapping
 * @param {Object} req - Request object with data containing storeId and products array
 * @returns {Promise} - API response
 */
function createBatchSizeMapping(req = {}) {
	const requestOptions = {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			...authHeader(),
		},
		body: JSON.stringify({
			...req?.data,
		}),
	};

	return fetch(endpoints.VARIANT_BATCH_SIZE_CREATE, requestOptions).then(
		handleResponse
	);
}

export default variantBatchSizeServices;
